import 'regenerator-runtime/runtime'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HMSRoomProvider } from '@100mslive/react-sdk'
import 'bootstrap/dist/css/bootstrap.min.css'
import './i18n'

import App from './App.jsx'
import './index.css'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter>
      <HMSRoomProvider>
        <App />
      </HMSRoomProvider>
    </BrowserRouter>
  </StrictMode>,
)
